import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.page.html'
})
export class NeqErrorPage implements OnInit {

  titleMessage = '';
  errorMessage = '';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  ngOnInit() {
    const reason = this.route.snapshot.queryParamMap.get('reason');
    switch (reason) {
      case 'no-license':
        this.titleMessage = 'label.common.error.no-license-title';
        this.errorMessage = 'label.common.error.no-license-message';
        break;
      case 'license-expired':
        this.titleMessage = 'label.common.error.license-expired-title';
        this.errorMessage = 'label.common.error.license-expired-message';
        break;
      case 'user-not-found':
        this.titleMessage = 'label.common.error.user-not-found-title';
        this.errorMessage = 'label.common.error.user-not-found-message';
        break;
      case 'unvalid-account':
        this.titleMessage = 'label.common.error.unvalid-account-title';
        this.errorMessage = 'label.common.error.unvalid-account-message';
        break;
      default:
        this.titleMessage = 'label.common.error.unknown-title';
        this.errorMessage = 'label.common.error.unknown-message';
    }
  }

  logout() {
    this.router.navigate(['logout']);
  }
}
